export enum StorageNames {
  pagesHistory = 'pagesHistory',
  pageEditor = 'pageEditor',
  pagesHistoryHome = 'pagesHistoryHome',
  userProfile = 'userProfile',
}



// WEBPACK FOOTER //
// ./src/constants/storageNames.ts